/* 事前審査申込完了 */
import React, { memo } from 'react';
import HeadingM from '../../molecules/HeadingM';
import ApplicationInformation from '../../molecules/ApplicationInformation';
import FooterPreExaminationApplicationInputComplete from '../../organisms/FooterPreExaminationApplicationInputComplete';

interface Props {
  ja_name: string;
  reception_cd: string;
  is_staff: boolean;
  opened_mypage: boolean;
}

const Finish: React.FC<Props> = ({ ja_name, reception_cd, is_staff, opened_mypage }) => {
  return (
    <>
      <HeadingM label="事前審査お申込み完了"></HeadingM>
      <div className="p-lead">
        お客様のお申込みを受け付けました。
        <br />
        ご登録のメールアドレスに事前審査受付メールを送信しました。
        <br />
        メールが届かない場合には申込先JAにお問合せ下さい。連絡先の電話番号はJAバンクホームページからご確認下さい。
        <br />
        本お取引におけるJAからのメールについては、「no-reply@entry.ja-netloan.jp」からのみ送信されます。
        <br />
        お問合せの際には申込番号が必要です。
      </div>
      <ApplicationInformation ja_name={ja_name} reception_cd={reception_cd} />
      <FooterPreExaminationApplicationInputComplete
        is_staff={is_staff}
        opened_mypage={opened_mypage}
      />
    </>
  );
};

export default memo(Finish);
